export default "__VITE_ASSET__DrKLA9Cc__"